/**
 * Mobile header navigation toggle.
 *
 * The header's `.tx-hdr__toggle` button is only visible below the lg
 * breakpoint and flips the `.is-open` class on `.tx-hdr__nav`, which the
 * stylesheet can use to expand the mobile drawer.
 */

const SELECTOR_TOGGLE = '.tx-hdr__toggle';
const SELECTOR_NAV    = '.tx-hdr__nav';
const OPEN_CLASS      = 'is-open';

const init = () => {
    const toggle = document.querySelector(SELECTOR_TOGGLE);
    const nav    = document.querySelector(SELECTOR_NAV);

    if (!toggle || !nav) return;

    toggle.addEventListener('click', () => {
        const open = nav.classList.toggle(OPEN_CLASS);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
};

document.addEventListener('DOMContentLoaded', init);
